import React from "react";
import Info from "../info/info";

const RequiredLabel = ({
  children,
  isRequired,
  infoMultiple,
}: {
  children: React.ReactNode;
  isRequired: boolean;
  infoMultiple?: boolean;
}) => (
  <>
    <label className="">
      {children}{" "}
      {isRequired ? (
        <sup className="text-danger">*</sup>
      ) : (
        <small className="text-secondary font-8">(Optional)</small>
      )}
    </label>{" "}
    {infoMultiple && <Info />}
  </>
);

export default RequiredLabel;
